import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const response = await axios.post('https://sunrisemeditechsystems.com/api/users/login', formData);
      // Login success થયા પછી
      console.log('User Login Success4343!', response.data);
      if (response.data.success) {
        localStorage.setItem("userToken", response.data.token);
        localStorage.setItem("currentUserId", response.data.user.id);
        toast.success("User Login Success!", {
          position: "top-right",
          autoClose: 3000, // 3 seconds
        });
        onClose();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed. Please try again.', {
        position: "top-right",
        autoClose: 3000, // 3 seconds
      });
    }
  };

  return (
    <div className="form-bg">
      <div className="form-card">
        {/* <h2 className="form-title">Login</h2> */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="email"
              placeholder="Username*"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-user"></i></span>
            {errors.email && <div className="form-error">{errors.email}</div>}
          </div>
          <div className="form-group">
            <input
              type="password"
              name="password"
              placeholder="Password*"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-lock"></i></span>
            {errors.password && <div className="form-error">{errors.password}</div>}
          </div>
          <button type="submit" className="form-btn">Login</button>
          {/* <div className="form-footer">
            DON'T HAVE AN ACCOUNT? <a href="/register">Register</a>
          </div> */}
        </form>
      </div>
      <style>{`
        .form-bg {
          min-height: 10vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f7fafd;
        }
        .form-card {
          background: #fff;
          border-radius: 2px;
          box-shadow: 0 4px 24px rgba(44, 123, 255, 0.10);
          padding: 40px 32px;
          width: 100%;
          max-width: 400px;
        }
        .form-title {
          text-align: center;
          color: #1a3c34;
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 28px;
        }
        .form-group {
          position: relative;
          margin-bottom: 8px;
        }
        .form-group input {
          width: 100%;
          padding: 14px 44px 14px 16px;
          border: 1.5px solid #e3e8ee;
          border-radius: 2px;
          font-size: 1rem;
          background: #f8fafc;
          transition: border 0.2s;
        }
        .form-group input:focus {
          border-color: #0A9A73;
          outline: none;
          background: #fff;
        }
        .form-group input.is-invalid {
          border-color: #dc3545;
        }
        .form-icon {
          position: absolute;
          right: 16px;
          top: 35%;
          transform: translateY(-50%);
          color: #0A9A73;
          font-size: 1.1rem;
        }
        .form-error {
          color: #dc3545;
          font-size: 0.95rem;
          margin-top: 4px;
        }
        .form-btn {
          width: 100%;
          padding: 12px;
          background: #0A9A73;
          color: #fff;
          border: none;
          border-radius: 2px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          margin-bottom: 10px;
          transition: background 0.2s;
        }
        .form-btn:hover {
          background: #0A9A73;
        }
        .form-footer {
          text-align: center;
          margin-top: 10px;
          color: #666;
        }
        .form-footer a {
          color: #0A9A73;
          text-decoration: none;
          font-weight: 500;
        }
        .form-footer a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}